export default __webpack_public_path__ + "static/media/openProject_grey.8ad602c3.svg";